import {AriaDateRangePickerProps, DateValue, useDateRangePicker} from 'react-aria';
import {DateRangePickerStateOptions, useDateRangePickerState} from 'react-stately';
import React, {useRef} from "react";
import {DateField} from "./DateField";
import {Popover} from "./Popover";
import {Dialog} from "./Dialog";
import {RangeCalendar} from "./Calendar";
import {CalendarIcon, ExclamationCircleIcon} from "@heroicons/react/24/outline";
import {useButton} from "@react-aria/button";


export function DateRangePicker(props: DateRangePickerStateOptions<DateValue> | AriaDateRangePickerProps<DateValue>) {

    const state = useDateRangePickerState(props);
    const ref = useRef(null);
    const {
        labelProps,
        groupProps,
        startFieldProps,
        endFieldProps,
        buttonProps,
        dialogProps,
        calendarProps
    } = useDateRangePicker(props, state, ref);

    return (
        <div>
            {props.label && (
                <div {...labelProps} className={'field-label'}>
                    {props.label}
                    {props.isRequired && <span className={'field-required'}>*</span>}
                </div>
            )}

            <div {...groupProps} ref={ref} className={'field-container gap-2 align-items-center justify-between'}>
                <div className="h-auto flex items-center">
                    <DateField {...startFieldProps} />
                    <span style={{padding: '0 4px'}}>–</span>
                    <DateField {...endFieldProps} />
                    {state.isInvalid && (
                        <ExclamationCircleIcon className="w-5 h-5 text-red-500 absolute right-1"/>
                    )}
                </div>
                <div className={'mr-1'} />
                <FieldButton {...buttonProps} isPressed={state.isOpen}>
                    <CalendarIcon className="w-5 h-5 text-gray-700"/>
                </FieldButton>
            </div>
            {state.isOpen && (
                <Popover state={state} triggerRef={ref} placement="bottom end" className={'p-4'}>
                    <Dialog {...dialogProps}>
                        <RangeCalendar {...calendarProps} firstDayOfWeek={props.firstDayOfWeek}/>
                        {/*<div className={'flex items-center'}>*/}
                        {/*    <Button>Letzte Woche</Button>*/}
                        {/*</div>*/}
                    </Dialog>
                </Popover>
            )}
        </div>
    );
}

export function FieldButton(props: any) {

    const ref = useRef<HTMLButtonElement | null>(null);
    const {buttonProps, isPressed} = useButton(props, ref);

    return (
        <button
            {...buttonProps}
            ref={ref}
            className={`px-1 py-0.5 transition-colors rounded-md group-focus-within:border-gray-600 group-focus-within:group-hover:border-gray-600 outline-none ${
                isPressed || props.isPressed
                    ? "bg-gray-200 border-gray-400"
                    : "bg-gray-100 border-gray-300 group-hover:border-gray-400"
            }`}>
            {props.children}
        </button>
    );
}